import * as actions from "./types";
import moment from "moment";

export const cartReadyForForm = (cart, changeRoute) => async (dispatch, getState) => {
    dispatch({ type: actions.CART_READY, payload: cart });
    changeRoute("/orderForm");
};

export const cartTotalReady = cart => async (dispatch, getState) => {
    let prices = cart.map(item => item.price * item.amount);
    let total;

    if (prices.length === 0) {
        total = "";
    } else {
        total = prices.reduce((acc, curr) => {
            return acc + curr;
        }, 0);
    }

    dispatch({ type: actions.TOTAL_READY, payload: total });
};

export const placeOrder = (order, form) => async (
    dispatch,
    getState,
    { getFirestore }
) => {
    const firestore = getFirestore();
    let newOrder = {
        form,
        order,
        ts: moment().format()
    };

    const ordersCollection = await firestore.collection("orders");
    dispatch({ type: actions.CART_ORDER_START });

    try {
        await ordersCollection.add({ newOrder });
        dispatch({ type: actions.CART_ORDER_SUCCESS });
        return true;
    } catch (e) {
        dispatch({ type: actions.CART_ORDER_FAIL, payload: e.message });
    }

    dispatch({ type: actions.CART_ORDER_END });
};
